(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedLocationSearch', MedLocationSearch);

    MedLocationSearch.$inject = ['$resource'];

    function MedLocationSearch($resource) {
        var resourceUrl =  'api/_search/med-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
